import { useEffect } from 'react';
import { useAgentState } from '@/context/agent-state.context';
import { useAnnotationCanvas } from '@/context/annotation-canvas.context';
import { rpcClient } from 'src/api/rpc/client';
import { captureScreen } from '@/utils/capture-screen';

export function useCaptureScreenHandler() {
  const { registerToolCallListener } = useAgentState();
  const { clear } = useAnnotationCanvas();

  useEffect(() => {
    return registerToolCallListener((toolCallId, toolName) => {
      if (toolName !== 'capture_screen') return;

      captureScreen()
        .then(({ imageData, mimeType, elements }) => {
          clear();
          return rpcClient.ai.chatAgent.submitScreenshot({
            toolCallId,
            imageData,
            mimeType,
            elements,
          });
        })
        .catch((err: unknown) => {
          console.error('[capture-screen] failed:', err);
        });
    });
  }, [registerToolCallListener, clear]);
}
